export default "__VITE_ASSET__3c4ad41b__"